import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { BisCampaignTabsComponent } from '@shared/components/bis-campaign-tabs/bis-campaign-tabs.component';
import { CampaignTypes } from '@shared/constants';
import {
  AccordionContentDirective,
  AccordionHeaderDirective,
  AccordionItemDirective,
} from '@shared/directives';
import { FaqConfigFirstVariant, Question } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [
    SafePipe,
    AccordionComponent,
    AccordionItemDirective,
    BisCampaignTabsComponent,
    AccordionHeaderDirective,
    AccordionContentDirective,
  ],
})
export class Variant1Component extends BaseComponent {
  config = input.required<FaqConfigFirstVariant>();

  public activeTab = this.dataService.activeTabs.faq;
  public expandedAccordions: Set<number> = new Set<number>();
  public questions: Signal<Question[]> = computed(() => {
    if (
      this.dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS
    ) {
      return (
        this.loyaltyChallengeConfig.pages.help.loyaltychallengeBis?.questions ||
        this.config().questions
      );
    }
    return this.config().questions;
  });

  changeTab(tab: CampaignTypes): void {
    this.dataService.activeTabs.faq.set(tab);
    this.dataService.syncWalletTab(tab);
  }

  isExpanded(event: boolean, index: number): void {
    if (event) {
      this.expandedAccordions.add(index);
    } else {
      this.expandedAccordions.delete(index);
    }
  }
}
